import { allEnumValues, CardEntryMethod, CardSchemeId, Gateway, TransactionResult, TransactionState, TransactionType, TransactionUserAction, } from '@biteinc/enums';
/**
 * A writeable version of the order schema. Used by the push API used by offline mode.
 */
export const transactionSchemaWriteable = {
    displayName: 'transaction',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
        },
        createdAt: {
            type: 'timestamp',
            required: true,
        },
        updatedAt: {
            type: 'timestamp',
            required: true,
        },
        clientId: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        clientOrderId: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
            // Short term id created on the client
        },
        orderId: {
            type: 'mongoId',
            isPermanent: true,
        },
        originalTransactionId: {
            type: 'mongoId',
            isPermanent: true,
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        refunderUserId: {
            type: 'mongoId',
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        refunderUsername: {
            type: 'keyString',
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        tenders: {
            type: 'array',
            elementType: 'object',
            fields: {
                amount: {
                    type: 'price',
                },
                surcharge: {
                    type: 'price',
                },
                cardSchemeId: {
                    type: 'int',
                    values: allEnumValues(CardSchemeId),
                },
                last4: {
                    type: 'keyString',
                },
                posTenderTypeID: {
                    type: 'keyString',
                },
                i9nId: {
                    type: 'keyString',
                },
            },
        },
        gateway: {
            type: 'int',
            values: allEnumValues(Gateway),
            required: true,
            isPermanent: true,
        },
        gatewaySoftwareVersion: {
            type: 'keyString',
            isPermanent: true,
        },
        kioskVersion: {
            type: 'keyString',
            isPermanent: true,
        },
        type: {
            type: 'int',
            values: allEnumValues(TransactionType),
            required: true,
            isPermanent: true,
        },
        amount: {
            type: 'price',
            required: true,
            isPermanent: true,
        },
        startedAt: {
            type: 'timestamp',
            required: true,
            isPermanent: true,
        },
        signatureCheckWasRequired: {
            type: 'bool',
            isPermanent: true,
        },
        userAction: {
            type: 'int',
            values: allEnumValues(TransactionUserAction),
            isPermanent: true,
        },
        finishedAt: {
            type: 'timestamp',
            required: true,
            isPermanent: true,
        },
        state: {
            type: 'int',
            values: allEnumValues(TransactionState),
            required: true,
            isPermanent: true,
        },
        result: {
            type: 'int',
            values: allEnumValues(TransactionResult),
            required: true,
            isPermanent: true,
        },
        cardSchemeId: {
            type: 'int',
            values: allEnumValues(CardSchemeId),
            isPermanent: true,
        },
        customCardSchemeName: {
            type: 'keyString',
            isPermanent: true,
        },
        cardEntryMethod: {
            type: 'int',
            values: allEnumValues(CardEntryMethod),
            isPermanent: true,
        },
        authCode: {
            type: 'keyString',
            isPermanent: true,
        },
        last4: {
            type: 'keyString',
            isPermanent: true,
        },
        maskPan: {
            type: 'keyString',
            isPermanent: true,
        },
        amountAuthorized: {
            type: 'price',
            isPermanent: true,
        },
        surcharge: {
            type: 'price',
            isPermanent: true,
        },
        cardReference: {
            type: 'keyString',
            isPermanent: true,
        },
        cardHolderName: {
            type: 'keyString',
        },
        cardHolderEmail: {
            type: 'email',
        },
        expiry: {
            type: 'keyString',
        },
        postalCode: {
            type: 'keyString',
        },
        sequenceNumber: {
            type: 'keyString',
            isPermanent: true,
        },
        currencyCode: {
            type: 'keyString',
            isPermanent: true,
        },
        transactionTime: {
            type: 'timestamp',
            isPermanent: true,
        },
        acquirerResponseCode: {
            type: 'keyString',
            isPermanent: true,
        },
        worldpayLaneId: {
            type: 'keyString',
            isPermanent: true,
        },
        receiptLocale: {
            type: 'keyString',
            isPermanent: true,
        },
        receiptText: {
            type: 'keyString',
            isPermanent: true,
        },
        i9nId: {
            type: 'keyString',
            isPermanent: true,
        },
        identifiedErrorCode: {
            type: 'int',
        },
        clientVersion: {
            type: 'int',
        },
        isReconciliation: {
            type: 'bool',
        },
        isTaxExempt: {
            type: 'bool',
        },
        json: {
            type: 'object',
            isFreeform: true,
        },
        commitJson: {
            type: 'object',
            isFreeform: true,
        },
        paymentsApiVersion: {
            type: 'keyString',
            isPermanent: true,
        },
        errors: {
            type: 'array',
            elementType: 'object',
            isFreeform: true,
            isPermanent: true,
        },
    },
};
//# sourceMappingURL=transaction_schema_writable.js.map